import type { ProjectId, ProjectKey } from './app';
import type { IssueId } from './issue';
import type { IssueTypeId } from './issue-type';

export const DEFAULT_ITEM_HEIGHT = 44;
export const DEFAULT_LIST_WIDTH = 320;
export const ITEM_HEIGHT_BASE_LEVEL = 32;
export const HEADER_HEIGHT = 56;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ListData = Record<any, any>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ChartData = Record<any, any>;

type BaseItem = {
	id: IssueId;
	level?: number;
	listData: ListData;
	chartData: ChartData;
};

export type Item = BaseItem & {
	childItems?: BaseItem[];
};

export type ChildItem = BaseItem;

export type ItemType = {
	id: IssueTypeId;
	name: string;
	iconUrl: string;
};

export type ExpandedItems = Record<IssueId, boolean>;

export type ItemTypes = {
	[level: number]: ItemType[];
};

export type ItemProject = {
	id: ProjectId;
	name: string;
	key: ProjectKey;
	itemTypes: ItemTypes;
	iconUrl: string;
};
